import { FooterInitialCompany } from './FooterInitialCompany';

export const Footer = ({ actions, allowOnBack, handleBack }) => {
    return (
        <FooterInitialCompany
            actions={actions}
            allowOnBack={allowOnBack}
            handleBack={handleBack}
        />
    );
};